import { useContext, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import PrimaryButton from '../../../components/PrimaryButton';
import AutoNavigate from '../../../components/AutoNavigate';
import { AppStateContext } from '../../../context/AppStateContextProvider';

const ExpandableText = ({ text }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Typography
            onClick={() => setIsExpanded((prev) => !prev)}
            sx={{
                fontSize: 16,
                fontWeight: 600,
                color: '#1f1f1f',
                mb: 2,
                cursor: 'pointer',
                ...(isExpanded
                    ? {}
                    : {
                          display: '-webkit-box',
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                      }),
            }}
        >
            {text}
        </Typography>
    );
};

export default function RideCompletedPage() {
    const { lastCompletedRideDetails, setLastCompletedRideDetails } = useContext(AppStateContext);
    const startLocationName = lastCompletedRideDetails?.pickupLocationName || 'Not available';
    const endLocationName = lastCompletedRideDetails?.destinationLocationName || 'Not available';
    const stopItems = Array.isArray(lastCompletedRideDetails?.stops)
        ? lastCompletedRideDetails.stops
        : [];
    const rideCost =
        typeof lastCompletedRideDetails?.fare?.value === 'number'
            ? `₹ ${lastCompletedRideDetails.fare.value.toFixed(2)}`
            : 'Not available';
    const isFreeRide = lastCompletedRideDetails?.isFreeRide === true;

    const routePoints = [
        { type: 'pickup', label: 'Pickup', value: startLocationName },
        ...stopItems.map((stop, index) => ({
            type: 'stop',
            label: `Stop ${index + 1}`,
            value: stop?.locationName || `Lat ${stop?.lat ?? '-'}, Long ${stop?.long ?? '-'}`,
        })),
        { type: 'dropoff', label: 'Drop-off', value: endLocationName },
    ];

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <AutoNavigate />
            <Box
                sx={{
                    backgroundImage: `url('/green-background.png')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100vw',
                    height: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img src="/tick-gif.gif" alt="" style={{ width: '150px', height: '150px' }} />
                <h1 style={{ color: '#ffffff', marginTop: '-10px' }}>Ride Completed !</h1>
            </Box>

            <Box
                sx={{
                    width: '100vw',
                    minHeight: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: 'rgb(242,242,242)',
                    padding: '24px 20px 32px',
                }}
            >
                <Box
                    sx={{
                        width: '80%',
                        maxWidth: '400px',
                        backgroundColor: '#ffffff',
                        borderRadius: '20px',
                        padding: '20px',
                        boxSizing: 'border-box',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                        margin: '16px',
                    }}
                >
                    {/* <Typography sx={{ fontSize: 16, color: "#6a6a6a", mb: 1 }}>Ride Cost</Typography> */}
                    <Typography
                        sx={{
                            fontSize: 24,
                            fontWeight: 700,
                            color: '#157347',
                            mb: 2,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        {isFreeRide ? 'This ride is on the house!' : rideCost}
                    </Typography>

                    <Typography sx={{ fontSize: 16, color: '#6a6a6a', mb: 1 }}>Route</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {routePoints.map((point, index) => (
                            <Box
                                key={`${point.type}-${index}`}
                                sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}
                            >
                                <Typography
                                    sx={{ fontSize: 14, color: '#6a6a6a', fontWeight: 600 }}
                                >
                                    {point.label}
                                </Typography>
                                <ExpandableText text={point.value} />
                            </Box>
                        ))}
                    </Box>
                </Box>

                <PrimaryButton
                    text="Back To Home Screen"
                    onClick={() => setLastCompletedRideDetails(null)}
                />
            </Box>
        </Box>
    );
}
